

export default function WhyTrial() {
  const features = [
    {
      icon: '📱',
      title: 'スキマ時間を活用',
      description: '単発1日からOK。今の生活を優先しながら、箕面園のプロの現場に関われます。',
    },
    {
      icon: '🏠',
      title: '体験から定着へ',
      description: 'まずは単発。気に入ればパートや正社員へ。ミスマッチのない転職を。',
    },
    {
      icon: '🤝',
      title: 'フラットな現場',
      description: '職種を越えて専門性を尊重しあう、温かい文化が箕面園の自慢です。',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-1.5 rounded-full text-sm font-medium mb-4">
            <i className="ri-building-2-line"></i>
            きらり保育園箕面園
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            なぜ、私たちが「<span className="text-teal-600">おためし</span>」を勧めるのか。
          </h2>
          <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto">
            どれだけ綺麗な求人票を見ても、実際に働いてみないと現場の空気はわかりません。 人間関係、看護と保育の連携、子供たちへのまなざし。 その「一番大切な部分」を納得して選んでほしいから、<strong className="text-teal-700">きらり保育園箕面園</strong>はオープンな採用を貫きます。
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="text-3xl mb-4">{feature.icon}</div>
              <h3 className="text-lg font-bold text-teal-600 mb-3">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
